var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "inline-block rounded-full bg-white p-1",
      style:
        "height:" + (_vm.size || 20) + "px; width:" + (_vm.size || 20) + "px"
    },
    [
      _c("span", {
        staticClass:
          "bg-contain bg-center bg-no-repeat inline-block align-middle h-full w-full",
        style:
          "background-image:url('../../../content/images/" +
          _vm.brandLogoPath +
          "';"
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }